"use client";

// src/primitives/contentPart/ContentPartImage.tsx
import { Primitive } from "@radix-ui/react-primitive";
import { forwardRef } from "react";
import { useContentPartImage } from "./useContentPartImage.js";
import { jsx } from "react/jsx-runtime";
var ContentPartPrimitiveImage = forwardRef((props, forwardedRef) => {
  const { image } = useContentPartImage();
  return /* @__PURE__ */ jsx(Primitive.img, { src: image, ...props, ref: forwardedRef });
});
ContentPartPrimitiveImage.displayName = "ContentPartPrimitive.Image";
export {
  ContentPartPrimitiveImage
};
//# sourceMappingURL=ContentPartImage.js.map